import { TopicNoteType } from '@/types/api';
import TopicNoteComponent from './TopicNote.component';

export type TopicNoteComponentProps = Partial<TopicNoteType> & {
  isSubmiting?: boolean;
  isEditing?: boolean;
  isNewInput?: boolean;
  onChangeHandler: (event: any) => void;
  onSaveNote: (index?: number) => void;
  onEditNote: (index?: number) => void;
  onUpdateNote?: (event: any, index?: number) => void;
  onDeleteNote: (index?: number) => void;
  onCancelEditingNote: (index?: number) => void;
};

const TopicNote = function (props: TopicNoteComponentProps): JSX.Element {
  return <TopicNoteComponent {...props} />;
};

export default TopicNote;
